import { useMutation } from "@apollo/client";
import { gql, TourType, UserTourStep } from "types";

const UPDATE_USER_DASHBOARD_TOUR = gql(/* GraphQL */ `
  mutation UpdateUserTour($input: UpdateUserTourInput!) {
    updateUserTour(input: $input) {
      id
      step
      lastClickedAt
    }
  }
`);

export const useUpdateUserTour = () => {
  const [updateUserTour, { loading }] = useMutation(
    UPDATE_USER_DASHBOARD_TOUR,
    {
      refetchQueries: ["Profile"],
    },
  );

  const updateTour = async (input: {
    step?: UserTourStep;
    lastClickedAt?: Date;
    type: TourType;
  }) => {
    await updateUserTour({
      variables: {
        input,
      },
    });
  };

  return {
    updateTour,
    loading,
  };
};
